var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-content"},[_c('ul',{staticClass:"menu-items"},[_vm._t("list",function(){return _vm._l((_vm.filteredMenu),function(m){return _c('menu-item',{key:m.id,attrs:{"m":m}})})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }